!function() {

  UC.views.AttorneyClientsNew = Backbone.View.extend({

    initialize: function() {
      new UC.views.AttorneyClientsForm();
    }

  })

}();
